<div id="dsw">
    <div class="popup-header z-index modal-header">
        <div class="flex-center space-between d-flex w-100">
            <h2 translate>lblAddContactDetails</h2>
            <em class="fas fa-times close-icn-popup popup-close ml-auto" (click)="activeModal.close(false)"></em>
        </div>
    </div>

    <form [formGroup]="contactDetailsForm" (ngSubmit)="onContactFormSubmit()">
        <div class="modal-body">
            <div class="row xsmbt0">
                <div class="col-3 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate> lblFirstName <strong class="mlt6 required"> * </strong> </label>
                        <input type="text" formControlName="FirstName" class="form-control" />
                        <div *ngIf="ContactFormControls.FirstName.touched || ContactFormControls.FirstName.dirty">
                            <div translate *ngIf="ContactFormControls.FirstName.errors?.required" class="cst-validation-msg">
                                lblRequiredFirstName
                            </div>
                            <div translate *ngIf="ContactFormControls.FirstName.errors?.pattern" class="cst-validation-msg">
                                lblSpecialCharactersAndDigitsAreNotAllowed</div>
                        </div>
                    </div>
                </div>
                <div class="col-3 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate> lblLastName <strong class="mlt6 required"> * </strong> </label>
                        <input type="text" formControlName="LastName" class="form-control" />
                        <div *ngIf="ContactFormControls.LastName.touched || ContactFormControls.LastName.dirty">
                            <div translate *ngIf="ContactFormControls.LastName.errors?.required" class="cst-validation-msg">
                                lbRequiredlLastName
                            </div>
                            <div translate *ngIf="ContactFormControls.LastName.errors?.pattern" class="cst-validation-msg">
                                lblSpecialCharactersAndDigitsAreNotAllowed</div>
                        </div>
                    </div>
                </div>
                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate> lblEmail <strong class="mlt6 required"> * </strong> </label>
                        <input type="email" formControlName="Email" maxlength="50" class="form-control" />
                        <div *ngIf="ContactFormControls.Email.touched || ContactFormControls.Email.dirty">
                            <div translate *ngIf="ContactFormControls.Email.errors?.required" class="cst-validation-msg">
                                lblEmailisrequired</div>
                            <div translate *ngIf="ContactFormControls.Email.errors?.pattern" class="cst-validation-msg">
                                lblPleaseEnterValidValue</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row xsmbt0">
                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate>lblMobileNo <strong class="mlt6 required"> * </strong> </label>
                        <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="MobileNo" [cssClass]="{'form-control': true}"
                        [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="false"
                        [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false"
                        (countryChange)="onCountryChange($event)"
                        ></ngx-intl-tel-input>
                        <div *ngIf="ContactFormControls.MobileNo.touched || ContactFormControls.MobileNo.dirty">
                            <div translate *ngIf="ContactFormControls.MobileNo.errors?.required" class="cst-validation-msg" translate>
                                lblMobileNumberIsRequired</div>
                            <div translate *ngIf="ContactFormControls.MobileNo.errors?.pattern" class="cst-validation-msg">
                                lblPleaseEnterValidValue</div>
                        </div>
                    </div>
                </div>
                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate>lblAddressLine1 <strong class="mlt6 required"> * </strong> </label>
                        <input type="text" formControlName="Address1" class="form-control" />
                        <div *ngIf="ContactFormControls.Address1.touched || ContactFormControls.Address1.dirty">
                            <div translate *ngIf="ContactFormControls.Address1.errors?.required" class="cst-validation-msg">
                                lblAddressLine1Required</div>
                        </div>
                    </div>
                </div>
                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate>lblAddressLine2 </label>
                        <input type="text" formControlName="Address2" class="form-control" />
                    </div>
                </div>
            </div>
            <div class="row xsmbt0">
                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate>lblZipCode<strong class="mlt6 required"> * </strong> </label>
                        <ng-select formControlName="Zipcode" (change)="onPostCodeSelected($event)">
                            <ng-option *ngFor="let item of postCodeList" [value]="item.code">
                                {{item.code}}
                            </ng-option>
                        </ng-select>
                        <div *ngIf="ContactFormControls.Zipcode.touched || ContactFormControls.Zipcode.dirty">
                            <div translate *ngIf="ContactFormControls.Zipcode.errors?.required" class="cst-validation-msg">
                                lblZipCodeIsRequired</div>
                        </div>
                    </div>
                </div>
                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate>lblCity <strong class="mlt6 required"> * </strong> </label>
                        <ng-select formControlName="City" (change)="onCitySelected($event)">
                            <ng-option *ngFor="let item of cityList" [value]="item">
                                {{item}}
                            </ng-option>
                        </ng-select>
                        <div *ngIf="ContactFormControls.City.touched || ContactFormControls.City.dirty">
                            <div translate *ngIf="ContactFormControls.City.errors?.required" class="cst-validation-msg">
                                lblCityIsRequired</div>
                        </div>
                    </div>
                </div>
                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate> lblCountry <strong class="mlt6 required"> * </strong> </label>
                        <ng-select formControlName="CountryId">
                            <ng-option *ngFor="let item of countryDropdown" [value]="item.id">
                                {{item.countryName}}
                            </ng-option>
                        </ng-select>
                        <div translate *ngIf="ContactFormControls.CountryId.touched || ContactFormControls.CountryId.dirty">
                            <div *ngIf="ContactFormControls.CountryId.errors?.required" class="cst-validation-msg" translate>
                                lblCountryIsRequired</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button translate type="submit" aria-label="Center Align" class="btn btn-primary btn-lg">
                lblAdd</button>
        </div>
    </form>
</div>
